import { UserProfile } from './user-profile.model';

export class UserProfileDetail extends UserProfile {}
